import * as React from 'react';
import { SelectionCard } from '../../../../shared/SelectionCard';

export interface ISSOProviderCardProps {
  onClick: () => void;
  selected: boolean;
  animationDelay?: number;
}

export const SSOProviderCard = React.memo(
  (props: ISSOProviderCardProps): React.ReactElement => {
    return (
      <SelectionCard
        selected={props.selected}
        onClick={props.onClick}
        icon='business'
        title='Single Sign-On (SSO)'
        description='Sign in with your organization account'
        animationDelay={props.animationDelay}
      />
    );
  },
  (
    prevProps: Readonly<ISSOProviderCardProps>,
    nextProps: Readonly<ISSOProviderCardProps>
  ): boolean => {
    return (
      prevProps.selected === nextProps.selected &&
      prevProps.onClick === nextProps.onClick &&
      prevProps.animationDelay === nextProps.animationDelay
    );
  }
);

SSOProviderCard.displayName = 'SSOProviderCard';
